import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store";
import Shortcuts from "@/components/shortcut/Shortcuts.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShortcutsPage',
  setup(__props) {

const store = useStore();

onMounted(() => {
  store.dispatch(Actions.GetShortcuts);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Shortcuts))
}
}

})